import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { translate, showMessageToastCustom, formatData, getUserNameToName, validationLatitude, validationLongitude } from '../../../utils/util';
import UnitService from '../../../services/UnitService';
import { validateInputsRequired, onValueChange } from '../../../utils/handleChangeHooks';
import { ENUMS } from '../../../utils/constants';
import { Breadcrumbs, Input, Select, Button, Label } from '../../../components/UI/ComponentsUI';

const UnitInsert = (props) => {
    const update = props.location?.state?.update;
    const areaId = props.location?.state?.areaId;
    const [unit, setUnit] = useState(props.location?.state?.update && props.unit ? props.unit : {
        areaId: areaId,
        code: '',
        description: '',
        latitude: '',
        longitude: '',
        unitTypeId: '',
        modalityId: '',
        warehouseTypeId: '',
        unitOrderingId: ''
    });

    const onChange = (event) => {
        onValueChange(event, unit, setUnit);
    };

    const onConfirm = () => {
        if (validateInputsRequired()) {
            let latitude = validationLatitude(document.querySelector('#latitude'));
            let longitude = validationLongitude(document.querySelector('#longitude'));
            if (latitude && longitude) {
                if (update) {
                    props.unitUpdate(unit, (response) => {
                        if (!response) {
                            showMessageToastCustom(translate('warning', 'general'), translate('failed-to-update', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                        } else {
                            props.history.go(-1);
                        }
                    });
                } else {
                    props.unitInsert(unit, (response) => {
                        if (!response) {
                            showMessageToastCustom(translate('warning', 'general'), translate('failed-to-include', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                        } else {
                            props.history.go(-1);
                        }
                    });
                }
            }
        }
    };

    const titleUnit = { icon: "mdi mdi-clipboard-check-outline", label: translate('menu.configuration', 'configuration') };

    const subtitlesUnit = () => {
        let subtitlesItems = [];
        subtitlesItems = [...subtitlesItems, { icon: "mdi mdi-archive", label: translate('menu.area', 'configuration') }];
        subtitlesItems = [...subtitlesItems, { icon: "mdi mdi-stack-overflow", label: translate('menu.unit', 'configuration') }];
        subtitlesItems = [...subtitlesItems, { label: update ? translate('menu.update', 'configuration') : translate('menu.insert', 'configuration') }];
        return subtitlesItems;
    }

    return (
        <div>
            <Breadcrumbs id="unitInsert" title={titleUnit} subtitles={subtitlesUnit()} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <form>
                                <div className="row" style={{ marginBottom: '0px' }}>
                                    <div className="input-field no-padding col s12">
                                        <Input required label={translate('fields.code', 'unit')} id="code" name="code" type="text" maxLength="13" onChange={onChange} value={unit?.code} />
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <Input required label={translate('fields.description', 'unit')} id="description" name="description" type="text" onChange={onChange} value={unit?.description} />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input required label={translate('fields.latitude', 'unit')} id="latitude" name="latitude" type="number" onChange={onChange} value={unit?.latitude} />
                                    </div>
                                    <div className="input-field no-padding col s6">
                                        <Input required label={translate('fields.longitude', 'unit')} id="longitude" name="longitude" type="number" onChange={onChange} value={unit?.longitude} />
                                    </div>
                                    <div className="row" style={{ marginBottom: '0px' }}>
                                        <div className="no-padding col s12">
                                            <Select
                                                required
                                                id="unitTypeId"
                                                name="unitTypeId"
                                                label={translate('fields.unitTypeId', 'unit')}
                                                placeHolder={translate('fields.unitTypeId', 'unit')}
                                                data={[{ id: ENUMS.eUnitType.Dock.value, text: translate(ENUMS.eUnitType.Dock.text, 'unitType'), },
                                                { id: ENUMS.eUnitType.Queue.value, text: translate(ENUMS.eUnitType.Queue.text, 'unitType') },
                                                { id: ENUMS.eUnitType.Addressing.value, text: translate(ENUMS.eUnitType.Addressing.text, 'unitType') },
                                                { id: ENUMS.eUnitType.EntranceArea.value, text: translate(ENUMS.eUnitType.EntranceArea.text, 'unitType') }
                                                ]}
                                                change={onChange}
                                                defaultValue={unit?.unitTypeId}
                                            />
                                        </div>
                                    </div>
                                    <div className="row" style={{ marginBottom: '0px' }}>
                                        <div className="no-padding col s12">
                                            <Select
                                                required
                                                id="modalityId"
                                                name="modalityId"
                                                label={translate('fields.modalityId', 'unit')}
                                                placeHolder={translate('fields.modalityId', 'unit')}
                                                data={[{ id: ENUMS.eModality.LinePicking.value, text: translate(ENUMS.eModality.LinePicking.text, 'modality') },
                                                { id: ENUMS.eModality.Load.value, text: translate(ENUMS.eModality.Load.text, 'modality'), },
                                                { id: ENUMS.eModality.Unload.value, text: translate(ENUMS.eModality.Unload.text, 'modality') },
                                                { id: ENUMS.eModality.LoadAndUnload.value, text: translate(ENUMS.eModality.LoadAndUnload.text, 'modality') }]}
                                                change={onChange}
                                                defaultValue={unit?.modalityId}
                                            />
                                        </div>
                                    </div>
                                    <div className="row" style={{ marginBottom: '0px' }}>
                                        <div className="no-padding col s12">
                                            <Select
                                                id="warehouseTypeId"
                                                name="warehouseTypeId"
                                                label={translate('fields.warehousetypeId', 'unit')}
                                                placeHolder={translate('fields.warehousetypeId', 'unit')}
                                                data={[
                                                    { id: ENUMS.eWareHouseType.SmallParts.value, text: translate(ENUMS.eWareHouseType.SmallParts.text, 'unitWarehouse') },
                                                    { id: ENUMS.eWareHouseType.Kanban.value, text: translate(ENUMS.eWareHouseType.Kanban.text, 'unitWarehouse') }]}
                                                change={onChange}
                                                defaultValue={unit?.warehouseTypeId}
                                            />
                                        </div>
                                    </div>
                                    {props.unitOrderingList.length > 0 &&
                                        <div className="row" style={{ marginBottom: '0px' }}>
                                            <div className="no-padding col s12">
                                                <Select
                                                    id="unitOrderingId"
                                                    name="unitOrderingId"
                                                    placeHolder={translate('fields.unitOrderingId', 'unit')}
                                                    data={props.unitOrderingList ? props.unitOrderingList.map((i) => { return { id: i.unitOrderingId, text: i.description }; }) : []}
                                                    change={onChange}
                                                    defaultValue={unit?.unitOrderingId}
                                                />
                                            </div>
                                        </div>
                                    }
                                </div>
                                {
                                    update &&
                                    <div className="row" style={{ marginBottom: '0px' }}>
                                        <Label label={translate('fields.updateBy', 'unit')} id="updateBy" value={getUserNameToName(props.usersFromElog, unit?.updateBy)} />
                                        <Label label={translate('fields.updateOn', 'unit')} id="updateOn" value={formatData(unit?.updateOn)} />
                                    </div>
                                }
                            </form>
                            <div className="row">
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        unit: state.unitReducer.unit,
        usersFromElog: state.usersElogReducer.usersElog,
        unitOrderingList: state.unitReducer.unitOrderingList

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        unitInsert: (unit, callback) => {
            dispatch(UnitService.AddUnit(unit, callback));
        },
        unitUpdate: (unit, callback) => {
            dispatch(UnitService.PutUnit(unit, callback));
        },

    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(UnitInsert)));
